import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import { MessageCircle, Copy, QrCode } from "lucide-react";

export function ShareProfile({ playerId, name, subtitle }) {
  const url = `${window.location.origin}/p/${playerId}`;
  const message = `🎾 ${name} — American Padel 2026\n${subtitle ? subtitle + "\n" : ""}Guarda il profilo: ${url}`;
  const wa = `https://wa.me/?text=${encodeURIComponent(message)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copiato");
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };

  return (
    <div className="flex flex-col sm:flex-row items-center gap-4" data-testid="share-profile">
      <div className="bg-white p-2.5 rounded-xl shrink-0">
        <QRCodeCanvas value={url} size={116} fgColor="#0B0F19" bgColor="#ffffff" level="M" />
      </div>
      <div className="flex-1 w-full space-y-2">
        <div className="flex items-center gap-2 text-sm text-slate-300">
          <QrCode className="w-4 h-4 text-emerald-400" />
          Inquadra il QR o condividi il link del profilo pubblico.
        </div>
        <div className="flex flex-wrap gap-2">
          <a
            data-testid="share-whatsapp-btn"
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold uppercase text-xs tracking-wide transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp
          </a>
          <button
            data-testid="share-copy-btn"
            onClick={copy}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800 hover:bg-slate-700 text-slate-100 border border-slate-700 font-bold uppercase text-xs tracking-wide transition-colors"
          >
            <Copy className="w-4 h-4" />
            Copia link
          </button>
        </div>
      </div>
    </div>
  );
}
